module.exports = __webpack_public_path__ + "img/slideVerify_09.2a6ff99b.png";